const isDev = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args) => { if (isDev) console.log('[XO]', ...args); },
  info: (...args) => { if (isDev) console.info('[XO]', ...args); },
  warn: (...args) => console.warn('[XO]', ...args),
  error: (...args) => console.error('[XO]', ...args),
  debug: (...args) => { if (isDev) console.debug('[XO]', ...args); },
};

export default logger;
